import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';
import { fetchMe, type Member } from './api.ts';

const Ctx = createContext<Member | null>(null);

/** Loads the signed-in member once so the app can gate commissioner controls. */
export function MeProvider({ children }: { children: ReactNode }) {
  const [me, setMe] = useState<Member | null>(null);
  useEffect(() => {
    fetchMe()
      .then(setMe)
      .catch(() => setMe(null));
  }, []);
  return <Ctx.Provider value={me}>{children}</Ctx.Provider>;
}

export function useMe(): Member | null {
  return useContext(Ctx);
}
